export default __webpack_public_path__ + "static/media/iconTalhao.a375383c.svg";